import { i18n } from '@fs/zion-locale'
import { Select } from '@fs/zion-ui'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

const languages = {
  // ‘all’ searches for all languages (in actual API request, the language param is not sent if lang was ‘all’)
  // https://github.com/fs-eng/photos-artifact-manager/blob/fead207467de0a8bc999ec6fc8adbb2249383fc6/artifact-manager-ws/src/main/java/org/familysearch/engage/artifactmanager/ws/ArtifactEndpoint.java#L80
  // The i18n translation key and default value are here and used by the useTranslation hook,
  // until I figure out a way to mock the i18n.t function from @fs/zion-locale
  all: ['artifacts.language.all', 'All'],
  en: ['artifacts.language.english', 'English'],
  de: ['artifacts.language.german', 'German'],
  es: ['artifacts.language.spanish', 'Spanish'],
  fr: ['artifacts.language.french', 'French'],
  it: ['artifacts.language.italian', 'Italian'],
  pt: ['artifacts.language.portuguese', 'Portuguese'],
  ru: ['artifacts.language.russian', 'Russian'],
  zh: ['artifacts.language.chinese', 'Chinese'],
  ja: ['artifacts.language.japanese', 'Japanese'],
  ko: ['artifacts.language.korean', 'Korean'],
}

/**
 * Used on the recent artifacts page to filter artifacts by their upload language
 */
const LanguageFilter = ({ value, onChange }) => {
  const [t] = useTranslation()
  return (
    <Select
      hidePlaceholder
      label={i18n.t('language.label', 'Language')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      name="languageFilter"
      options={Object.keys(languages).map((lang) => ({
        value: lang,
        label: t(`lang.${languages[lang][1].toLowerCase()}`, languages[lang][1].toLowerCase()),
      }))}
    />
  )
}

LanguageFilter.propTypes = {
  value: PropTypes.oneOf(Object.keys(languages)).isRequired,
  // This callback will be passed a language code: oneOf(Object.keys(languages)), e.g. ‘fr’
  onChange: PropTypes.func.isRequired,
}

export default LanguageFilter
